import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class SystemManagerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  // SYSTEMCONFIGURATION
  getSystemConfigurations (): Observable<any> {
    const systemconfigurationsEndPoint = `${environment.API_URL}/systemManager`
    return this.http.get(systemconfigurationsEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  updateSystemConfigurations (data): Observable<any> {
    const systemconfigurationsEndPoint = `${environment.API_URL}/systemManager/edit`
    return this.http.post(systemconfigurationsEndPoint, data, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
